<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ch2"> </p>
<p class="CN"><span href="#/xhtml/contents#c_ch2" title="Link target outside of Sample"><span class="ePub-B">2</span></span></p>
<p class="CO">Behind that window in the old camp was the face of a boy with crew-cut hair and glasses. I lifted my hand off the tiller and gave him a weak wave. The boy waved back, then disappeared. After a moment he stepped onto the rickety-looking deck that fronted the house, holding a hammer. He appeared to be close to my age, but a little on the small side. He was barefoot, filthy dirty, and his clothes were torn in several places. His face and arms were dotted with so many insect bites it looked like he had chicken pox. He adjusted his glasses and studied me.</p>
<p class="TX">“Hey,” he called.</p>
<p class="TX">“Hey,” I called back.</p>
<p class="TX">“What you doin’ out here?” he asked me.</p>
<p class="TX">“Nothing,” I said.</p>
<p class="TX">He kept staring at me.</p>
<p class="TX">“Where’d you come from?” I asked.</p>
<p class="TX">He pointed to a place beside the camp. “I paddled that boat.”</p>
<p class="TX">I saw the outline of a canoe almost completely hidden in the marsh grass.</p>
<p class="TX">“The canoe?”</p>
<p class="TX">“Yeah. You gonna tell anybody?”</p>
<p class="TX">I shook my head. “No.”</p>
<p class="TX">He smiled. I felt myself relaxing, mostly convinced I wasn’t talking to a ghost.</p>
<p class="TX">“I like your boat,” he said.</p>
<p class="TX">“Thanks.”</p>
<p class="TX">“You wanna come see my camp?”</p>
<p class="TX">I thought about it. “Okay,” I finally said.</p>
<p class="TX">I motored over to what was left of a narrow boat dock. Most of the boards were gone. The boy came across the front deck like there wasn’t anything wrong with it, stepping over rotten places and open holes and down onto the dock to help me. I met him at the front of the boat and gave him my bowline. He took it and wrapped it around a nail.</p>
<p class="TX">“I need a cleat,” he said, meaning a metal hook to fasten boat ropes to.</p>
<p class="TX">I thought it strange he would think of something minor like that.</p>
<p class="TX">I stepped carefully onto the dock and looked back at my boat to make sure it wasn’t floating too close to any debris that might scratch it.</p>
<p class="TX">“It’ll be okay,” the boy said, like he knew what I was thinking.</p>
<p class="TX">I turned to him. “I didn’t know people could have camps out here anymore.”</p>
<p class="TX">“Yeah, they told my brother it was fine.”</p>
<p class="TX">“Who told him?”</p>
<p class="TX">The boy shrugged. “I don’t know. Whatever person he asked. This used to be our camp about five years ago. Before the government took it away.”</p>
<p class="TX">“You build it?”</p>
<p class="TX">“Daddy and my brother did. I wasn’t old enough. But I used to come stay in it with ’em.”</p>
<p class="TX">“You’re lucky it didn’t get burned like those others.”</p>
<p class="TX">He turned and admired the dilapidated old structure. “I know. I’ve been tryin’ to get the orange paint off. Come see the rest.”</p>
<p class="TX">I followed him up the dock and onto the deck, stepping carefully in his footsteps.</p>
<p class="TX">“What’s your name?” I asked him.</p>
<p class="TX">“Davey,” he said. “What’s yours?”</p>
<p class="TX">“Sam Ford,” I said.</p>
<p class="TX">We stepped into the camp and I looked about the dark room. It was no more than sixteen feet wide and twelve feet deep. It was definitely leaning, but inside it wasn’t as noticeable. The roof had obviously been leaking for a while. The plywood floor, damp and stained, flexed under my feet. The place smelled of rotting wood and animal pee. Against the wall was a bunk bed. The mattresses had holes on the sides where rats had torn into them and pulled out the stuffing. To my left was a countertop with a sink and old dishes and a coffeemaker. An old charcoal grill sat on the floor.</p>
<p class="TX">“It won’t take me long,” Davey said. “I swept most of it out already. I just need some wood.”</p>
<p class="TX">“Where’s your dad and your brother?”</p>
<p class="TX">“They’re comin’,” he said.</p>
<p class="TX">“How long have you been out here?”</p>
<p class="TX">“About a week.”</p>
<p class="TX">“By yourself?”</p>
<p class="TX">“Sort of. I have a mouse. You wanna see?”</p>
<p class="TX">Davey went to the counter, where there was a rusty cooking pot. He looked into it, then held it out to me. I peered in and saw a ball of what looked like mattress stuffing.</p>
<p class="TX">“Feel in there,” he said.</p>
<p class="TX">I didn’t like the idea of poking my finger into a mouse nest. “Will it bite?”</p>
<p class="TX">“It’s just a baby,” Davey said. “I was cleanin’ and I messed up its nest. The momma ran off.”</p>
<p class="TX">I nudged the nest and saw a hairless pink mouse baby. Its eyes were closed and it was no bigger than the tip of my thumb. The mouse squirmed at the disturbance and worked its way back into the stuffing.</p>
<p class="TX">“I named him Baldy,” Davey said.</p>
<p class="TX">I replaced the stuffing over Baldy and backed away.</p>
<p class="TX">“What do you and Baldy eat?” I asked.</p>
<p class="TX">“Well, we need some more food. And some boards.”</p>
<p class="TX">“You don’t have any food?”</p>
<p class="TX">“I caught some fish. And I found three cans of beans in the cabinet under the sink.”</p>
<p class="TX">“What are you drinking?”</p>
<p class="TX">“Dr Pepper. We left it up here.”</p>
<p class="TX">“You mean, like, five years ago?”</p>
<p class="TX">“Yeah, I guess.”</p>
<p class="TX">I watched him, thinking maybe this was all a joke he was playing. He didn’t appear to be joking at all.</p>
<p class="TX">I had so many questions I didn’t know where to start. “When are your dad and brother getting here?”</p>
<p class="TX">“I don’t know. Soon.”</p>
<p class="TX">“Like today or tomorrow or what?”</p>
<p class="TX">“I don’t know.”</p>
<p class="TX">“But all you have is a canoe. What if they don’t come for a week?”</p>
<p class="TX">Davey adjusted his glasses. “They should be here by then, for sure,” he said.</p>
<p class="TX">“How can you stay here without any food?” I said. “You don’t even have bedding or anything, and it looks like a thousand mosquitoes have bitten you.”</p>
<p class="TX">“They’re gonna bring everything I need.”</p>
<p class="TX">“But you need it now.”</p>
<p class="TX">Davey smiled and grabbed a broom leaning against the wall. He made a couple of sweeps across the floor and smiled. “They’ll come,” he said. “Real soon.”</p>
<p class="TX">It was almost eleven o’clock and I needed to get back in time for lunch. Just an hour before, I would have sworn I’d never venture into the swamp again, but now there was something irresistible about this strange boy and his swamp camp.</p>
<p class="TX">I got some insect repellent out of the tackle box in my boat and brought it to him. “You can have this,” I said.</p>
<p class="TX">“Thanks,” he said.</p>
<p class="TX">“I’ll bring some food,” I told him. “But I have to go home first and check in with my parents.”</p>
<p class="TX">“What about some cheese for Baldy?”</p>
<p class="TX">“You think Baldy’s big enough for cheese?”</p>
<p class="TX">“I don’t know. What do you think?”</p>
<p class="TX">“Milk, I’d say.”</p>
<p class="TX">Davey watched me expectantly as I got back into my boat.</p>
<p class="TX">“I’ll try and bring some,” I said.</p>
<p class="TX">He smiled like it was something he couldn’t help, excitement rising into his eyes.</p>
<p class="TX">“Can you spend the night?” he asked.</p>
<p class="TX">“My parents wouldn’t let me,” I said. “I’m not even supposed to be this far away from our house.”</p>
<p class="TX">A little of the excitement faded from his face, but the smile stayed.</p>
<p class="TX">“But I’ll bring you a sleeping bag. Okay?”</p>
<p class="TX">“Okay,” he said.</p>
<p class="TX">Davey shoved my boat off and I backed away from the dock.</p>
<p class="TX">He gave a small wave. “See you this afternoon.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?d51615e0